// Feature 161: opzioni chart.js comuni a barre e ciambella (legenda e tick responsive), prima duplicate nei due
// componenti. La Chat AI (ai-chat-grafico-dati.ts) usa colori di tema e legenda propri: non li condivide.

export const MEDIA_MOBILE_GRAFICI = '(max-width: 767px)';

export function isMobileGrafico(): boolean {
  return window.matchMedia(MEDIA_MOBILE_GRAFICI).matches;
}

/** Legenda in alto su desktop e in basso su telefono; `boxWidth` = [telefono, desktop]. */
export function legendaResponsive(mobile: boolean, boxWidth: [number, number]) {
  return {
    position: (mobile ? 'bottom' : 'top') as 'bottom' | 'top',
    labels: {
      boxWidth: mobile ? boxWidth[0] : boxWidth[1],
      boxHeight: mobile ? 10 : 12,
      padding: mobile ? 8 : 12,
      font: {
        size: mobile ? 10 : 12
      }
    }
  };
}

export function fontTick(mobile: boolean) {
  return {size: mobile ? 10 : 11};
}
